export default "__VITE_ASSET__e1c760bd__"